/* add to cart */

function addToCart(){

  // if(!selectedVariant){
    var active = document.querySelector('.qty-card.active');
    var selectedVariant = active.dataset.variant;
  // }
   selectedQty = document.querySelector('.qty-card.active').getAttribute('data-qty');
   selectedVariant = document.querySelector('.qty-card.active').getAttribute('data-variant');
  //  console.log(selectedVariant);
   document.querySelector('.cart-btn-add-cart')?.classList.add("loading");
  fetch('/cart/add.js', {
    method:'POST',
    headers:{
      'Content-Type':'application/json'
    },
    body:JSON.stringify({
      id:selectedVariant,
      quantity:1
    })
  })
  .then(res=>res.json())
  .then(data=>{

   

    fetch('/?sections=cart-drawer,cart-icon-bubble')
  .then(res => res.json())
  .then(data => {

   


    const parser = new DOMParser();

    /* PARSE DRAWER */

    const drawerHTML = parser.parseFromString(data["cart-drawer"], "text/html");
    const newDrawer = drawerHTML.querySelector("cart-drawer");
    const currentDrawer = document.querySelector("cart-drawer");

    if (!newDrawer || !currentDrawer) {
      console.error("Cart drawer not found");
      return;
    }

    /* REPLACE DRAWER CONTENT */

    currentDrawer.innerHTML = newDrawer.innerHTML;

    /* IMPORTANT FIX (Dawn empty state) */

    currentDrawer.classList.remove("is-empty");

    /* UPDATE CART ICON BUBBLE */

    const bubbleHTML = parser.parseFromString(data["cart-icon-bubble"], "text/html");
    const newBubble = bubbleHTML.querySelector("#cart-icon-bubble");
    const currentBubble = document.querySelector("#cart-icon-bubble");

    if (newBubble && currentBubble) {
      currentBubble.innerHTML = newBubble.innerHTML;
    }

    /* OPEN DRAWER WITH DAWN ANIMATION */

    if (typeof currentDrawer.open === "function") {
      currentDrawer.open();
    } else {
      currentDrawer.classList.add("active");
      document.body.classList.add("overflow-hidden");
    }
    document.querySelector('.cart-btn-add-cart')?.classList.remove("loading");

  })

  });

}